import { useContext } from 'react';
import HighlightKey from '~/constants/common/highlightKey';
import DiscountContext from '~/context/vdp/DiscountContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

type KBBPromo = {
  showKBBPromo: boolean;
  kbbPromoAmount: number;
  displayPrice: number;
};

export default function useKBBPromo(): KBBPromo {
  const { price = 0, kbbValue = 0, highlights } = useGetVehicleDetails();
  const { totalDiscount } = useContext(DiscountContext);

  const hasGreatDealHighlight =
    highlights?.some(({ tagKey }) => tagKey === HighlightKey.GreatDeal) ??
    false;
  const displayPrice = price - totalDiscount;
  const kbbValuePriceDifference = kbbValue - displayPrice;

  return {
    showKBBPromo: hasGreatDealHighlight,
    kbbPromoAmount: kbbValuePriceDifference,
    displayPrice
  };
}
